export class ThemeEvents {
  static discountUpdate = "discount:update";
}

export class DiscountUpdateEvent extends Event {
  constructor(resource, sourceId) {
    super(ThemeEvents.discountUpdate, { bubbles: true });
    this.detail = { resource, sourceId };
  }
}

document.addEventListener("cart-update", () => {
  localStorage.removeItem("shippingRates");
  localStorage.removeItem("selectedShippingRate");

  // Auto-recalcular frete se há CEP salvo
  const cartShippingComponent = document.querySelector(
    "cart-shipping-component"
  );

  if (cartShippingComponent) {
    cartShippingComponent.autoRecalculateShipping();
  }
});

// Listener para eventos de desconto (cupons aplicados/removidos)
document.addEventListener("discount:update", () => {
  localStorage.removeItem("shippingRates");
  localStorage.removeItem("selectedShippingRate");

  // Auto-recalcular frete se há CEP salvo
  const cartShippingComponent = document.querySelector(
    "cart-shipping-component"
  );
  if (cartShippingComponent) {
    cartShippingComponent.autoRecalculateShipping();
  }
});

// Listener para atualizar valor do frete
document.addEventListener("shipping:update", ({ detail }) => {
  // Adiciona o preço na listagem de totals do carrinho lateral
  const shippingPriceListItem = document.querySelector(
    ".previewCartTotals.shipping"
  );
  if (shippingPriceListItem) {
    shippingPriceListItem.querySelector(
      ".previewCartTotals-value"
    ).textContent = detail.fmtBRL(detail.price);
    shippingPriceListItem.style.display = detail.removed ? "none" : "block";
  }

  // Recalcula o total
  const totalPriceListItem = document.querySelector(".previewCartTotals.total");
  if (totalPriceListItem) {
    const oldTotalValue =
      totalPriceListItem.querySelector(".previewCartTotals-value")?.dataset
        ?.cartTotalValue / 100;
    let newTotalValue = detail.removed
      ? oldTotalValue
      : oldTotalValue + +detail.price;

    const formattedValue = Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(newTotalValue);

    totalPriceListItem.querySelector(".previewCartTotals-value").textContent =
      formattedValue;
  }
});
